<app-loader [loading]="isLoading"></app-loader>
<ng-container *ngIf="!eInvoice?.salesInvoiceId || eInvoice?.eInvoiceStatus === 4; else registerEInvoice">
  <button type="button" class="btn btn-primary gap-2" (click)="sendToEInvoiceSystem()">
    <icon-e-invoice />
    {{ "e-invoice.registerInEInvoice" | translate }}
  </button>
</ng-container>

<ng-template #registerEInvoice>
  <div hlMenu>
    <button hlMenuButton type="button" class="btn btn-primary gap-1" (click)="toggleMenuVisibility()"><icon-e-invoice /> {{ "download_confirmation_einvoice" | translate }}</button>
    <div class="mr-50 flex flex-col items-center">
      <div class="absolute z-20 mt-8 rounded-lg bg-white pt-5 opacity-95 shadow-lg transition-opacity">
        <ul *hlMenuItems @toggleAnimation>
          <div class="space-y-3 px-2 py-2 text-blue-600">
            <button type="button" class="btn btn-primary flex w-full items-center justify-center gap-2" (click)="downloadSalesInvoice(eInvoice.salesInvoiceId)">
              <icon-eye></icon-eye>
              {{ "download_confirmation_einvoice" | translate }}
            </button>
            <button type="button" class="btn btn-primary flex w-full items-center justify-center gap-2" (click)="stornoInvoice()">
              <icon-accounting-data></icon-accounting-data>
              {{ "storno_quick_label" | translate }}
            </button>
          </div>
        </ul>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #modalEInvoiceTemplate>
  <div class="flex flex-col p-4">
    <ng-container *ngIf="bill">
      <app-e-invoice [bill]="bill" (updated)="closeEInvoiceModal()"></app-e-invoice>
    </ng-container>
  </div>
</ng-template>

<ng-template #einvoicePdfModalTemplate>
  <div class="flex flex-col p-4">
    <div class="!pb-5 text-xl">{{ "e-invoice.invoice_viewer" | translate }}</div>
    <app-e-invoice-pdf-viewer *ngIf="fileUrl" [fileUrl]="fileUrl" [modalPdf]="einvoicePdfModalTemplate"></app-e-invoice-pdf-viewer>
  </div>
</ng-template>

<ng-template #modalStornoTemplate>
  <div class="flex flex-col p-4">
    <div class="!pb-5 text-xl">{{ "e-invoice.cancel_travel_sale" | translate }}</div>
    <app-e-invoice-storno [billId]="bill.id" [invoiceId]="eInvoice.salesInvoiceId" (updated)="closeStornoModal()" [type]="'FINAL'"></app-e-invoice-storno>
  </div>
</ng-template>
